import ContractPage from '@pages/Editais/Contratacao';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/editais/contratacao/')({
  component: ContractPage,
});
